import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

enum SupportedLanguages {
  de = 'de-DE',
  en = 'en-US',
  fr = 'fr-FR',
  es = 'es-ES',
}

export const LangMenu = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        size="large"
        color="inherit"
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {i18n.language.substring(0, 2)}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          onClick={() => {
            i18n.changeLanguage(SupportedLanguages.de);
            handleClose();
          }}
        >
          DE
        </MenuItem>
        <MenuItem
          onClick={() => {
            i18n.changeLanguage(SupportedLanguages.en);
            handleClose();
          }}
        >
          EN
        </MenuItem>
        <MenuItem
          onClick={() => {
            i18n.changeLanguage(SupportedLanguages.fr);
            handleClose();
          }}
        >
          FR
        </MenuItem>
        <MenuItem
          onClick={() => {
            i18n.changeLanguage(SupportedLanguages.es);
            handleClose();
          }}
        >
          ES
        </MenuItem>
      </Menu>
    </div>
  );
};
